import { DarDto } from 'data';

export const generateVersion = (str) => {
  const regexDarFileVersion = /\d{1,2}\.\d{1,2}\.\d{1,3}/;
  const v = regexDarFileVersion.exec(str);

  if (v !== null) {
    return v[0];
  }
  return undefined;
};

export const preparingFileListData = (fileList) =>
  (fileList?.map((el) => {
    return {
      name: el.label,
      version: generateVersion(el.label) || '',
    };
  }) || []) as DarDto[];

export const formatBytesDecimal = (bytes: number): string => {
  const units = ['B', 'KB', 'MB', 'GB', 'TB', 'PB'];

  if (bytes === 0) return '0 B';

  const i = Math.floor(Math.log(bytes) / Math.log(1000));
  const value = bytes / 1000 ** i;

  return `${value.toFixed(2)} ${units[i]}`;
};

export const formatBytesBinary = (bytes: number): string => {
  const units = ['B', 'KiB', 'MiB', 'GiB', 'TiB', 'PiB'];

  if (bytes === 0) return '0 B';

  const i = Math.floor(Math.log(bytes) / Math.log(1024));
  const value = bytes / 1024 ** i;

  return `${value.toFixed(2)} ${units[i]}`;
};
